import React from 'react';
import { motion } from 'framer-motion';
import { projects } from '../data/mock';
import { MapPin, Maximize2, Award, ArrowRight } from 'lucide-react';

const ProjectsSection = () => {
  return (
    <section id="projects" className="py-20 md:py-28 bg-[#0F172A]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="badge-minimal-dark mb-6">
            Our Portfolio
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            Featured <span className="text-[#8ABDE0]">Projects</span>
          </h2>
          <p className="text-base text-white/60 max-w-2xl mx-auto">
            Explore our recent cleanroom installations across North America, 
            from pharmaceutical facilities to cutting-edge research labs.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="group rounded-xl overflow-hidden bg-white/5 border border-white/10 hover:border-[#8ABDE0]/30 transition-all"
            >
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-3 py-1 text-xs font-semibold text-white bg-[#1C4B8A] rounded">
                    {project.classification}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-[#8ABDE0] transition-colors">
                  {project.title}
                </h3>
                <div className="space-y-2 text-sm text-white/60">
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-[#8ABDE0]" />
                    {project.location}
                  </div>
                  <div className="flex items-center gap-2">
                    <Maximize2 className="w-4 h-4 text-[#8ABDE0]" />
                    {project.size}
                  </div>
                  <div className="flex items-center gap-2">
                    <Award className="w-4 h-4 text-[#8ABDE0]" />
                    {project.scope}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-6 py-3 text-white bg-[#1C4B8A] rounded-lg hover:bg-[#153A6B] transition-colors"
          >
            Discuss Your Project
            <ArrowRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectsSection;
